import { render } from "./CardioQnrFailed.vue?vue&type=template&id=0ef2e2f7&scoped=true"
import script from "./CardioQnrFailed.vue?vue&type=script&lang=js"
export * from "./CardioQnrFailed.vue?vue&type=script&lang=js"

import "./CardioQnrFailed.vue?vue&type=style&index=0&id=0ef2e2f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef2e2f7"]])

export default __exports__